export default {"src":"/_next/static/media/citizenship-certificate.43fa93d9.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};